import React, { useState, useRef, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import endpoints from '_apis';
import { _ } from '_locales';
import axios from 'axios';
import { cts_secure } from '../../../../app/cts';
import Question from '../components/Question';

import { Image, PollRow, OptionsContainer } from '../components';

import * as actions from '../../redux/actions';
import { Button } from '../../components';
import eventTracker from '../../../../helpers/eventTracker';
import events from '../../events';

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const Container = styled.div`
  display:flex;
  flex-direction:column;
  animation: ${OpacityAnimation} 0.7s;
`;

const Carousel = styled.div`
  display: flex;
  justify-content: center;
`;

const HorizontalBullet = styled.div`
  height: 10px;
  margin: 10px 3px;
  background-color: ${({ isCurrentSlide }) => (isCurrentSlide ? '#76CBC4' : 'rgba(0, 0, 0, 0.06)')} ;
  width: ${({ isCurrentSlide }) => (isCurrentSlide ? '20px' : '10px')} ;
  border-radius: 10px;
`;

const Poll = ({
  wwtkItems,
  uuid,
  projectId,
  districtId,
  zones,
  setWwtkDoneItem,
  selectedLang,
  doneActivities,
  colors,
  ...props
}) => {
  const { main_color } = colors;
  const coachable = props;
  const {
    district_id,
    campaign_id,
    oidx,
    nextkeyTitle,
    done,
    correct_answer_feedback,
    coachable_id,
    message,
    type,
    image_path,
    wrong_answer_feedback,
    quiz_correct_answer,
    poll_quiz_question: pollQuizQuestion,
    ...options
  } = coachable;
  const [description, setDescription] = useState(pollQuizQuestion);
  const [buttonActive, setButtonActive] = useState(true);
  const [optionStats, setOptionStats] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const imgRef = useRef();
  const [canContinue, setCanContinue] = useState(false);

  useEffect(() => {
    setButtonActive(true);
    setCanContinue(false);
    setOptionStats([]);
    setSelectedOption(null);
    setDescription(pollQuizQuestion);
  }, [coachable_id, selectedLang, campaign_id]);

  /**
   * Option press handler that redirects user to results screen.
   * @param {*} item
   */
  const optionPressHandler = (item) => {
    if (buttonActive) {
      const selected = item.split('_')[item.split('_').length - 1];
      setSelectedOption(selected);
      feedbackToServer(selected);
      eventTracker(
        events.HOME_SCREEN_WWTK_POLL_OPTION_SELECT,
        {
          selected_option: selected,
          campaign_id,
          coachable_id,
        }
      );
    }
  };

  /**
   * Feedback to server
   */
  const feedbackToServer = async (theOption) => {
    try {
      const payload = {
        uuid,
        project_id: projectId,
        district_id: districtId,
        campaign_id,
        coachable_id,
        user_choice: theOption,
        zone: zones,
        source: 'webapp'
      };

      const { data: { poll_results } } = await cts_secure('post', endpoints.wwtkFeedback('poll'), payload);
      setOptionStats(poll_results);
      setCanContinue(true);
    } catch (e) {
      // TODO: Log error
    }
  };

  /**
   * Current Quiz data
   */
  const currentActivity = wwtkItems
    .find((activity) => activity.coachable_id === coachable_id
      && activity.campaign_id === campaign_id);

  /**
    * Index of the current Quiz
    */
  const index = wwtkItems
    .findIndex(({ coachable_id, campaign_id }) => coachable_id === currentActivity.coachable_id
      && campaign_id === currentActivity.campaign_id);

  /**
    * Array of string, each element is equal to 'otherSlide'
    * except for the element with index of current Slide which has value of 'currentSlide'
    */
  const bullets = Array(wwtkItems.length).fill('otherSlide');
  bullets[index] = 'currentSlide';

  return (
    <Container>
      <OptionsContainer imageRef={imgRef}>
        <>
          {/* image */}
          {
            image_path
              ? (
                <Image
                  ref={imgRef}
                  link={endpoints.getCampaignImage(image_path)}
                  alt={`${description} image`}
                />
              ) : null
          }

          {/* question */}
          <Question
            content={description}
          />

          {/* answers */}
          {
            Object.keys(options).length
              ? Object.keys(options).map((option, i) => (
                (options[option])
                  ? (
                    <PollRow
                      title={options[option]}
                      selectedOption={selectedOption}
                      pressHandler={() => optionPressHandler(option)}
                      optionStat={optionStats}
                      optionValue={option}
                      disabled={!!selectedOption}
                      index={i}
                    />
                  ) : null
              )) : null
          }
        </>
        <div style={{ marginTop: 'auto' }}>
          {/* ask me another button */}
          {
            canContinue
              ? (
                <Button
                  mainColor={main_color || false}
                  margin="20px 10px 15px auto"
                  onClick={() => {
                    if (buttonActive) {
                      setButtonActive(false);
                      const doneItem = { coachableId: coachable_id, campaignId: campaign_id };
                      setWwtkDoneItem(JSON.stringify(doneItem));
                    }
                  }}
                >
                  {doneActivities.length === wwtkItems.length - 1 ? _('resources.finish') : _('resources.ask_me_another')}
                </Button>
              ) : null
          }
          {/* carousel indicators */}
          <Carousel>
            {bullets.map((bullet) => <HorizontalBullet isCurrentSlide={bullet === 'currentSlide'} />)}
          </Carousel>
        </div>
      </OptionsContainer>
    </Container>
  );
};

export default connect(
  (store) => ({
    wwtkItems: store.education.wwtk_items || null,
    doneActivities: store.wwtk.doneActivities || [],
    uuid: store.plugin.uuid,
    projectId: store.plugin.projectId,
    districtId: store.config.districtId,
    zones: store.zone.zoneStr,
    selectedLang: store.config.selectedLang,
    colors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
  }),
  (dispatch) => ({
    setWwtkDoneItem: (id) => dispatch(actions.setWwtkDoneItem(id))
  })
)(Poll);
